export default __webpack_public_path__ + "static/media/Sri K. Ramachandra Mohan.86ed221d.png";